import { notifyError } from 'data/App/sagas'
import { call, put, takeEvery } from 'redux-saga/effects'
import { getFee } from 'services/api/markets'

import { actions } from './slice'

const fetchSaga = function* (action) {
  const { payload: currency } = action
  const data = yield call(getFee, currency)
  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
    return
  }
  // const getMinorUnits = yield select(selectors.currencies.getMinorUnitsFactory)
  // yield put(fetchByCurrencySuccess(currency, data.response, getMinorUnits))
  yield put(actions.setMetadata(data.response))
}

export default function* withdrawlSagas() {
  yield takeEvery(actions.fetch.type, fetchSaga)
}
